<template>
	<svg
		version="1.2"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 345 336"
		width="18px"
		height="18px">
		<linearGradient
			id="g1"
			x1="9.858"
			x2="38.142"
			y1="9.858"
			y2="38.142"
			gradientUnits="userSpaceOnUse">
			<stop
				offset="0"
				stop-color="#9dffce" />
			<stop
				offset="1"
				stop-color="#50d18d" />
		</linearGradient>
		<path
			style="fill: url(#g1)"
			d="m23 168c0-82.8 67.2-150 150-150 82.8 0 150 67.2 150 150 0 82.8-67.2 150-150 150-82.8 0-150-67.2-150-150z" />
	</svg>
</template>
<script>
export default {
	name: 'Uncheck'
}
</script>
<style lang=""></style>